<template>
   <div class="voucher">
      <div class="top-content clearfix">
         <img src="/img/volane-logo.svg" alt="" class="logo">
         <div class="right-content clearfix r">
            <div class="content-box clearfix">
               <div class="h5 r">VOLANE</div>
            </div>
            <div class="help r help-large">E: vouchers@volanedev.com | Help Line: +254789898086</div>
         </div>
      </div>

      <div class="row justify-content-md-center">
         <div class="col-md-11 col-lg-10 col-xl-9">
            <div class="wizard-container">
               <div class="fx-wizard page">
                  <div class="wizard-head clearfix">
                     <div class="head-content clearfix" :class="{'active': current === 1}">
                        <div class="icon l fa fa-user-tie"></div>
                        <div class="w-content l">
                           <div class="fx-h6">User Details</div>
                           <div class="text-muted">Provide your details</div>
                        </div>
                     </div>
                     <div class="head-content clearfix" :class="{'active': current === 2}">
                        <div class="icon l fa fa-money-check-alt"></div>
                        <div class="w-content l">
                           <div class="fx-h6">Voucher Cards</div>
                           <div class="text-muted">Request one or many voucher cards</div>
                        </div>
                     </div>
                     <div class="head-content clearfix" :class="{'active': current === 3}">
                        <div class="icon l fa fa-mobile-alt"></div>
                        <div class="w-content l">
                           <div class="fx-h6">Request Payment</div>
                           <div class="text-muted">Request voucher payment via m-pesa</div>
                        </div>
                     </div>
                     <div class="head-content clearfix" :class="{'active': current === 4}">
                        <div class="icon l fa fa-check-square"></div>
                        <div class="w-content l">
                           <div class="fx-h6">Confirm Payment</div>
                           <div class="text-muted">Confirm voucher payment</div>
                        </div>
                     </div>
                  </div>
                  <div class="wizard-pages">
                     <div class="wizard-page">
                        <div class="page-content" v-show="current === 1">
                           <Form 
                              class_binding="row justify-content-md-center" 
                              :ref="Model.forms.customer_details.name" 
                              :forms="Model.forms.customer_details.forms" 
                              :form_data="Model.forms.customer_details.data"
                           />
                        </div>
                        <div class="page-content" v-show="current === 2">
                           <TableForm 
                              class_binding="row justify-content-md-center" 
                              :ref="Model.forms.voucher_cards.name" 
                              v-bind="Model.forms.voucher_cards"
                           />
                        </div>
                        <div class="page-content" v-show="current === 3">
                           <Form 
                              class_binding="row" 
                              :ref="Model.forms.payment_type.name" 
                              :forms="Model.forms.payment_type.forms" 
                              :form_data="Model.forms.payment_type.data"
                           />
                        </div>
                        <div class="page-content" v-show="current === 4">
                           <div class="row">
                              <div class="col-md-11 col-lg-9 col-xl-8">
                                 <div class="txt-container" v-show="!is_payment_made && !payment_failed">
                                    <div class="h5 clearfix tx-warning">
                                       <div class="fa fa-clock l"></div> 
                                       <div class="text l">
                                          Waiting for Payment.
                                       </div>
                                    </div>
                                    <div class="txt">
                                       We are currently waiting for payment. If payment has been made and you are still seeing this message <b class="link" @click="checkPaymentStatus">Click Here</b>.
                                    </div>
                                    <div class="txt mt-4">In case you cancelled the payment request <b class="link" @click="payVoucher({payment_type: $refs[Model.forms.payment_type.name]})">Click Here!</b> To send another one</div>
                                 </div>

                                 <div class="txt-container" v-show="is_payment_made">
                                    <div class="h5 clearfix tx-success">
                                       <div class="fa fa-check-circle l"></div> 
                                       <div class="text l">
                                          Payment Successful.
                                       </div>
                                    </div>
                                    <div class="txt">
                                       Your payment has been confirmed. We have sent voucher codes for each card to the respective users. We have also sent a backup for that to your email address.
                                    </div>

                                    <div class="txt mt-4"><b>Rubis Team.</b></div>
                                 </div>

                                 <div class="txt-container" v-show="!is_payment_made && payment_failed">
                                    <div class="h5 clearfix tx-danger">
                                       <div class="fa fa-exclamation-triangle l"></div> 
                                       <div class="text l">
                                          Payment Failed.
                                       </div>
                                    </div>
                                    <div class="txt">
                                       We have noticed that your payment failed. For the reason below: 
                                    </div>
                                    <div class="txt mt-3"><b>{{failure_reason}}</b></div>
                                    <div class="txt mt-3"><b class="link" @click="payVoucher({payment_type: $refs[Model.forms.payment_type.name]})">Click Here</b>, To send another payment request.</div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="wizard-actions clearfix" v-show="!is_payment_made">
                     <div class="btn l" v-if="current > 0 && current != 3" @click="previousPage" :disabled="loading">Previous <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div></div>
                     <div 
                        class="btn btn-primary r" 
                        v-show="current < 4" 
                        disabled="loading" 
                        @click="nextPage({customer_details: $refs[Model.forms.customer_details.name],voucher_cards: $refs[Model.forms.voucher_cards.name],payment_type: $refs[Model.forms.payment_type.name]})"
                     >
                        Next
                        <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                     </div>
                     <!-- <div class="btn btn-primary r" v-show="current === 3" disabled="loading" @click="submit">
                        Finish
                        <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                     </div> -->
                  </div>
               </div>
            </div>
         </div>
      </div>
      
      <div class="foot">
         <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10 col-xl-9">
               <div class="row">
                  <div class="col-lg-5">
                     <div class="txt">&copy; {{new Date().getFullYear()}} <b>Purplefire LTD.</b> All Rights Reserved</div>
                  </div>
                  <div class="col-lg-7">
                     <div class="links r">
                        <a href="#" class="link">Terms &amp; Condition</a>
                        <a href="#" class="link">VOLANE LTD</a>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import voucher from "./voucher.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('voucher')
   },
   created(){
      Event.$emit('loader:show',true)
      utils.registerModule('voucher',voucher,this.$store)
   },
   components:{
      Form: () => import("clarks/components/form"),
      TableForm: () => import("clarks/components/form-input-table"),
   },
   data (){
      return {
         dayjs,
         utils
      };
   },
   computed: {
      ...mapGetters([
         'Model',
         'voucher',
         'is_payment_made',
         'failure_reason',
         'payment_failed',
         'current',
         'loading',
      ])
   },
   methods: {
      ...mapActions([
         'fetchData',
         'previousPage',
         'checkPaymentStatus',
         'payVoucher',
         'nextPage',
         'handleActions',
      ]),
   },
   async mounted(){
      utils.registerModule('voucher',voucher,this.$store)
      await this.fetchData()
   }
}
</script>

<style lang="scss">
   .voucher{
      background: #f7f8fc;
      min-height: 100vh;
      
      .txt-container{
         padding: 30px 5px;

         .h5{
            margin: 0 0 15px 0;
            .fa{
               font-size: 30px;
            }
            .text{
               margin: 5px 0 0 15px;
            }
         }
         .txt{
            font-size: 14px;
         }
      }
      .wizard-container{
         margin-bottom: 100px;
      }
      .foot{
         position: fixed;
         padding: 10px 15px;
         background: $white;
         left: 0;
         right: 0;
         bottom: 0;

         .txt{
            font-size: 12px;
         }

         .link{
            font-size: 12px;
            margin: 0 10px 0 0;
         }
      }
      .fx-wizard{
         .head-content{
            padding: 20px 15px 20px 10px !important;

            .icon{
               font-size: 30px !important;
               width: 35px;
               text-align: center;
               margin: 0 15px 0 0;
            }
            .w-content{
               width: calc(100% - 50px);
            }
            .fx-h6{
               font-size: 13px;
               margin: 6px 0 0 0;
               font-weight: bold;
               text-transform: uppercase;
            }
            .text-muted{
               margin: -2px 0 0 0;
            }

            &.active{
               background: #f7f8fcc7;

               .icon{
                  color: $primary;
               }
            }
         }
      }
      .page{
         background: $white;
         margin: 50px 0 0 0;
      }
      .filter{
         margin: 10px 0 20px 0;
      }
      .top-content {
         background: $white;
         padding: 10px 15px;

         .content-box{

         }
         .logo {
            width: 70px;
            height: auto;
            margin: 20px 0 0 0;
         }
         .card-img {
            max-width: 100px;
            max-height: 100px;
            width: auto;
            height: auto;
         }
         .h5 {
            margin: 5px 0 0 0;
            font-weight: $weight-bold;
         }
         .help {
            margin: 10px 0 0 0;
            font-weight: $weight-bold;
            color: grey;
            font-size: 12px;
         }
      }

   }

@media(max-width: $breakpoint-md){
   .voucher{
      .top-content {
         .logo{
            width: 60px !important;
         }
      }
      .fx-wizard{
         .wizard-head{
            display: block !important;

            .head-content{
               border-bottom: solid 1px $border-grey;
            }
         }
      }
   }
}

@media(max-width: $breakpoint-sm){
   .voucher{
      .top-content {
         position: relative;
   
         .logo{
            width: 60px !important;
            position: absolute;
            top: 18px;
         }
         .card-img {
            max-width: 90px !important;
            max-height: 90px !important;
         }
         .h5{
            font-size: 16px;
         }
         .help {
            margin: 20px 15px 0 0 !important;
         }
         .help-small{
            display: block !important;
            text-align: right;
         }
         .help-large{
            display: none;
         }
      }
   }
}
</style>